export const AdServerType = {
	ADBUTLER: 'adbutler',
};
